<template>
    <b-spinner v-if="!spark"></b-spinner>
    <div v-else>
        <b-tabs>
            <b-tab :title="$t('general')">
                <b-row>
                    <b-col cols="12" md="6">
                        <b-card>
                            <b-row>
                                <b-col cols="12">
                                    <protokol-settings-dropdown size="sm" class="pull-right">
                                        <b-dropdown-item-button @click="remove"> {{ $t('delete') }} </b-dropdown-item-button>
                                    </protokol-settings-dropdown>
                                </b-col>
                                <b-col cols="12" class="mb-2">
                                    <b-form-group
                                        :label="$t('name')"
                                    >
                                        <b-input v-model="spark.name" disabled/>
                                    </b-form-group>

                                    <b-form-group
                                        :label="$t('runtime')"
                                    >
                                        <b-input v-model="spark.lang" disabled/>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="4" class="mb-2">
                                    <b-input-group-append>
                                        <b-dropdown :text="`IDE: ${ideVersion}`">
                                            <b-dropdown-item v-for="version in availableVersion" :key="version" @click="previewVersion = version"> {{ version }} </b-dropdown-item>
                                            <b-dropdown-divider />
                                            <b-dropdown-item @click="forkModal = true" v-if="spark.dev_version != ''"> {{ $t('fork') }} </b-dropdown-item>
                                            <b-dropdown-item @click="removeVersion()" v-if="spark.dev_version != ''"> {{ $t('remove') }} </b-dropdown-item>
                                        </b-dropdown>
                                    </b-input-group-append>
                                </b-col>
                                <b-col cols="4" md="4"  class="mb-2">
                                    <b-dropdown
                                        :text="'Dev: ' + devVersion"
                                    >
                                        <b-dropdown-item v-for="version in availableVersion" :key="version" @click="publishDevVersion(version)">{{ version }}  <b-badge variant="success" v-if="version == spark.dev_version"> {{ $t('redeploy') }} </b-badge></b-dropdown-item>
                                        <b-dropdown-divider />
                                        <b-dropdown-item @click="publishDevVersion('')" v-if="spark.dev_version != ''"> {{ $t('deactivate') }} </b-dropdown-item>
                                    </b-dropdown>
                                </b-col>

                                <b-col cols="12" md="4">
                                    <b-dropdown
                                        v-if="isReady('live')"
                                        :text="'Live: ' + liveVersion"
                                    >
                                        <b-dropdown-item v-for="version in availableVersion" :key="version" @click="publishLiveVersion(version)">{{ version }} <b-badge variant="success" v-if="version == spark.public_version"> {{ $t('redeploy') }} </b-badge></b-dropdown-item>
                                        <b-dropdown-divider />
                                        <b-dropdown-item @click="publishLiveVersion('')" v-if="spark.public_version != ''"> {{ $t('unpublish') }} </b-dropdown-item>
                                    </b-dropdown>
                                    <b-dropdown
                                        v-else
                                        text="Live"
                                        disabled
                                    >
                                    </b-dropdown>
                                </b-col>
                            </b-row>
                        </b-card>
                    </b-col>
                    <b-col cols="12" md="6">
                        <b-row>
                            <b-col cols="12" v-if="handlerExpression">
                                <CodeEditor v-model="handlerExpression" :withButton="false" :readOnly="ideVersion == liveVersion" :controls="false"/>
                            </b-col>
                            <b-col cols="12"  v-if="packageExpression">
                                <CodeEditor v-model="packageExpression" :withButton="false" :readOnly="ideVersion == liveVersion" :controls="false"/>
                            </b-col>
                            <b-col cols="12" v-if="handlerExpression && packageExpression" :disabled="ideVersion == liveVersion"> <b-button @click="save" variant="success" block>{{ $t('save') }}</b-button> </b-col>
                        </b-row>
                        
                    </b-col>
                </b-row>
            </b-tab>
            <b-tab :title="$t('environment')">
                <b-form-group
                    :label="$t('environment')"
                    :label-cols="2"
                >
                    <b-dropdown
                        :text="env"
                        >
                        <b-dropdown-item @click="env = 'dev'"> dev </b-dropdown-item>
                        <b-dropdown-item @click="env = 'live'"> live </b-dropdown-item>
                    </b-dropdown>
                </b-form-group>

                <b-form-group
                    :label="$t('envVariables')"
                    :label-cols="2"
                >
                    <CodeEditor lang="application/json" :controls="false" v-model="envVariables" sidebar>
                        <b-button variant="success" @click="save()" class="ml-3">{{ $t('save') }}</b-button>
                    </CodeEditor>
                </b-form-group>
            </b-tab>
            <b-tab :title="$t('logs')">
                <b-form-group
                    :label="$t('environment')"
                    :label-cols="2"
                >
                    <b-dropdown
                        :text="env"
                        >
                        <b-dropdown-item @click="env = 'dev'"> dev </b-dropdown-item>
                        <b-dropdown-item @click="env = 'live'" v-if="spark.public_version != ''"> live </b-dropdown-item>
                    </b-dropdown>
                </b-form-group>

                <b-col>
                    <div class="terminalLog">
                        <ul>
                            <li v-for="(log, index) in logs" :key="index"> {{ log }} </li>
                            <li v-if="spark.public_version == '' && spark.dev_version == ''"> {{ $t('inOrderToSeeLogs') }} </li>
                            <template v-else>
                                <li v-if="!logInterval"><b-button @click="inspectLogs" size="sm">{{ $t('inspect') }}</b-button></li>
                                <li v-if="logInterval"><b-spinner type="grow" small/> <a href="#" @click="stopLog">{{$t('stop')}}</a> </li>
                            </template>
                        </ul>
                    </div>
                </b-col>
            </b-tab>
        </b-tabs>
        <b-modal v-model="forkModal" :ok-title="$t('fork')" @ok="forkVersion">
            <b-form-group
                :label="$t('version')"
            >
                <b-input v-model="previewVersion" disabled></b-input>
            </b-form-group>

            <b-form-group
                :label="$t('newVersion')"
            >
                <b-input v-model="forkTo"></b-input>
            </b-form-group>
        </b-modal>
    </div>
</template>
<script>
import CodeEditor from '@/components/form/Editor/Code'
import { get, cloneDeep } from 'lodash'

export default {
    name: 'Spark',
    components: {
        CodeEditor
    },
    data: function() {
        return {
            spark: null,
            ideVersion: this.previewVersion || "Choose",
            forkModal: false,
            forkTo: null,
            env: "dev",
            logs: [],
            logInterval: null
        }
    },
    computed: {
        availableVersion() {
            return this.spark.settings.map(s => {
                return s.version
            })
        },

        previewVersion: {
            get() {
                return this.spark.dev_version
            },

            set(val) {
                this.ideVersion = val
            }
        },

        liveVersion() {
            return this.spark.public_version || "not live"
        },

        devVersion() {
            return this.spark.dev_version || "not active"
        },

        handlerExpression: {
            get() {
                let settings = this.spark.settings.find(s => {
                    return s.version == this.ideVersion
                })

                return get(settings, 'dist.handler', null)
            },

            set(val) {
                let settings = this.spark.settings.find(s => {
                    return s.version == this.ideVersion
                })

                settings.dist.handler = val
            }
        },

        packageExpression: {
            get() {
                let settings = this.spark.settings.find(s => {
                    return s.version == this.ideVersion
                })

                return get(settings, 'dist.package', null)
            },

            set(val) {
                let settings = this.spark.settings.find(s => {
                    return s.version == this.ideVersion
                })

                settings.dist.package = val
            }
        },

        envVariables: {
            get() {
                return JSON.stringify(get(this.spark.info, `${this.env}.env_vars`, {}) || {}, null, 4)
            },

            set(vars) {
                vars = JSON.parse(vars)
                this.spark.info[this.env].env_vars = vars
            }
        }
    },
    methods: {
        removeVersion() {},
        async publishLiveVersion(version) {
            let previousVersion = this.spark.public_version

            let confirm = await this.$bvModal.msgBoxConfirm(this.$t('areYouSure'))
            if (!confirm) return
            
            const popup = this.$loadingPopup()

            this.spark.public_version = version
            if (version == '') {
                version = 'none'
            }

            this.$sandbox.spark().release(this.$route.params.id, version)
            .catch(err => {
                this.$bvToast.toast(this.$t("unexpectedError"), {
                    title: this.$t("error"),
                    variant: "danger",
                })
                this.spark.public_version = previousVersion
            }).finally(() => {
                popup.hide()

                this.$bvToast.toast(this.$t('changesInProgress'), {
                    variant: "success"
                })
            })
        },
        async publishDevVersion(version) {
            let previousVersion = this.spark.dev_version
            let confirm = await this.$bvModal.msgBoxConfirm(this.$t('areYouSure'))
            if (!confirm) return

            const popup = this.$loadingPopup()
            this.spark.dev_version = version
            if (version == '') {
                version = 'none'
            }
            this.$sandbox.spark().deploy(this.$route.params.id, version)
            .catch(err => {
                this.$bvToast.toast(this.$t("unexpectedError"), {
                    title: this.$t("error"),
                    variant: "danger",
                })
                this.spark.public_version = previousVersion
            }).finally(() => {
                popup.hide()

                this.$bvToast.toast(this.$t('changesInProgress'), {
                    variant: "success"
                })
            })
        },
        forkVersion() {
            let settings = this.spark.settings.find(s => {
                return s.version == this.previewVersion
            })

            let settingsToFork = cloneDeep(settings)
            settingsToFork.version = this.forkTo

            this.spark.settings.push(settingsToFork)

            this.save()
        },
        save() {
            let popup = this.$loadingPopup()
            this.$sandbox.spark().update(this.$route.params.id, this.spark).finally(() => {
                popup.hide()
            })
        },

        async remove() {
            let confirm = await this.$bvModal.msgBoxConfirm(this.$t('areYouSure'))
            if (!confirm) return

            this.$sandbox.spark().delete(this.$route.params.id).then(() => {
                this.$router.go("/admin/spark")
            }).catch(() => {
                this.$bvToast.toast(this.$t("unexpectedError"), {
                    title: this.$t("error"),
                    variant: "danger",
                })
            })
        },

        isReady(env) {
            return this.spark.info[env].status != ""
        },

        inspectLogs() {
            this.logInterval = setInterval(async () => {
                try {
                    let now = new Date()
                    let s = now.getSeconds()
                    now.setSeconds(s - 5)

                    let resp = await this.$sandbox.spark().logs(this.$route.params.id, this.env, {since:now,size:1024})
                    this.logs = this.logs.concat(resp.data)
                } catch(err) {
                    this.$bvToast.toast(this.$t("unexpectedError"), {
                        title: this.$t("error"),
                        variant: "danger",
                    })

                    this.$debugLog(err)

                    clearInterval(this.logInterval)
                    this.logInterval = null
                }

            }, 5000)
            
        },

        stopLog() {
            clearInterval(this.logInterval)
            this.logInterval = null
        }
    },

    destroy() {
        clearInterval(this.logInterval)
        this.logInterval = null
    },

    mounted() {
       this.$sandbox.spark().get(this.$route.params.id).then(resp => {
            this.spark = resp.data
       }).catch(err => {
           this.$debugLog(err)
           this.$bvModal.msgBoxOk("Failed to fetch spark.")
       })
    }
}
</script>

<style scoped>
.terminalLog {
    background-color: black;
    color: #ccc;
    font-size: 15px;
    font-family: 'Lucida Sans Unicode';
    max-height: 400px;
    overflow-y: scroll;
    padding: 10px;
}

.terminalLog ul {
    list-style-type: "→";
}

.terminalLog ul > li {
    padding: 2px;
}
</style>